import { all } from 'redux-saga/effects';
import authSagas from './Auth';
import settingSagas from './Setting';
import profileSagas from './Profile';

export default function* rootSaga() {
  yield all([authSagas(), settingSagas(), profileSagas()]);
}
